export default __webpack_public_path__ + "static/media/16.5033c86a.jpg";